/**
 * After `wageproTwoFactor.enable` / `disable` the server has already replaced
 * the caller's session (and destroyed the old one). In the native shell the
 * replacement id arrives in the response body and must be stored, or every
 * later request would present the destroyed session and 401.
 *
 * If storing it fails, the only honest recovery is a fresh sign-in: the
 * two-step change itself DID happen, but this device no longer holds a
 * working session. Resolves `false` after starting that navigation.
 */
import type { NativeSessionCarrier } from '../../lib/auth/native_shell_auth.js';
import { persistNativeSession } from '../../lib/auth/native_shell_auth.js';
import { setNativeSessionToken } from '../../lib/auth/native_session_store.js';
import { buildLoginPath } from '../../lib/auth/wagepro_login_logic.js';

export async function storeReplacementSession(
  result: NativeSessionCarrier,
  native: boolean,
): Promise<boolean> {
  let stored: boolean;
  try {
    stored = await persistNativeSession(result, {
      native,
      setToken: (token) => setNativeSessionToken(token, { native }),
    });
  } catch (err) {
    console.error('[wagepro-web] storing the replacement session failed:', err);
    stored = false;
  }
  if (!stored) {
    window.location.href = buildLoginPath({ forceReauth: true });
  }
  return stored;
}
